import { Section } from "@react-email/components";
import { EmailButton } from "@/email/components/EmailButton";
import { EmailHeading } from "@/email/components/EmailHeading";
import { EmailLink } from "@/email/components/EmailLink";
import { EmailText } from "@/email/components/EmailText";
import { EmailWrapper } from "@/email/components/EmailWrapper";
import { isOurTenant } from "@/store/tenant/selectors";
import { ITenant } from "@/types/tenant";

interface ResetPasswordEmailProps {
    resetPasswordLink: string;
    tenant: ITenant | null;
    name?: string;
}

const ResetPasswordEmail = ({
    resetPasswordLink,
    name = "User",
    tenant,
}: ResetPasswordEmailProps) => {
    const is1TemplateTenant = isOurTenant(tenant);
    const preview = is1TemplateTenant
        ? "1Template password reset"
        : "Password reset";
    const contactEmail = tenant?.contactEmail || "hello@1template.io";
    return (
        <EmailWrapper
            preview={preview}
            tenant={tenant}
        >
            <Section>
                <EmailHeading noMarginBottom>Reset your password</EmailHeading>
                <Section>
                    <EmailButton href={resetPasswordLink}>
                        Reset password
                    </EmailButton>
                    <EmailText>Hi {name},</EmailText>
                </Section>
                <EmailText>
                    We received a request to reset your password.
                </EmailText>
                <EmailText>
                    Please click on the link above to reset your password within
                    the next 2 hours.
                </EmailText>
                <EmailText>
                    If you did not request a password reset, please contact us
                    at{" "}
                    <EmailLink href={`mailto:${contactEmail}`}>
                        {contactEmail}
                    </EmailLink>
                    .
                </EmailText>
            </Section>
        </EmailWrapper>
    );
};

ResetPasswordEmail.PreviewProps = {
    resetPasswordLink: "https://1template.io",
} as ResetPasswordEmailProps;

export default ResetPasswordEmail;
